import React, { useEffect } from "react";
import NavbarEnlaces from "../../../layout/NavbarEnlaces";
import Accordion from "../../../layout/Accordion/Accordion";
import AccordionItem from "../../../layout/Accordion/AccordionItem";
import { dataGaleria } from "../../../data/dataOIC";

export const GaleriaOIC = () => {
  useEffect(() => {
    document.title = "Galería OIC";
  }, []);

  return (
    <div className="margin-bottom-2">
      <NavbarEnlaces title="Órgano Interno de Control - Galería" />

      <Accordion idAccordion="galeriaOIC">
        {dataGaleria.map((infoAccordion) => (
          <AccordionItem
            key={infoAccordion.id}
            flushID={infoAccordion.flushID}
            titleItem={infoAccordion.titleItem}
            idAccordion="galeriaOIC"
            contentItem={infoAccordion.children.map((item) => (
              <div key={item.id} className="w-75 mx-auto mb-3">
                <ul className="list-group">
                  {item.subChildren.map((doc) => (
                    <li
                      key={doc.id}
                      className="list-group-item d-flex justify-content-between align-items-center"
                    >
                      <span>
                        <i className="fa fa-file-pdf text-danger me-2"></i>
                        {doc.title}
                      </span>

                      <a
                        href={doc.pdfUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="btn btn-outline-danger btn-sm"
                      >
                        <i className="fa fa-eye me-1"></i>
                        Abrir PDF
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          />
        ))}
      </Accordion>
    </div>
  );
};

export default GaleriaOIC;
